import React from 'react';
import { FileTextIcon, ZapIcon, SmartphoneIcon, FlagIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { PriceBlock } from './PriceBlock';
import { HERO_IMAGE_URL } from '../utils/headMeta';
import { PRODUCT_FACTS } from './salesData';
const HERO_IMG = HERO_IMAGE_URL;
/** Intrinsic size of the mockup — used to reserve layout space (avoids CLS). */
const HERO_IMG_WIDTH = 1024;
const HERO_IMG_HEIGHT = 1024;
const badges = [{
  icon: FileTextIcon,
  label: '100% PDF'
}, {
  icon: ZapIcon,
  label: 'Acceso en 5 min'
}, {
  icon: FlagIcon,
  label: 'Hecho para Argentina'
}, {
  icon: SmartphoneIcon,
  label: 'Instagram → Alumnos'
}];
export function Hero() {
  return <section className="relative overflow-hidden bg-sand" data-id="element-113" data-mp="ncgjad4b0lso">
      <div className="absolute -top-24 -right-24 h-72 w-72 rounded-full bg-stone/50 blur-3xl" aria-hidden data-id="element-114" data-mp="nbydopvr4v83" />
      <div className="absolute -bottom-32 -left-24 h-80 w-80 rounded-full bg-sage-soft/50 blur-3xl" aria-hidden data-id="element-115" data-mp="3czflm08u696k" />

      <div className="relative mx-auto max-w-3xl px-6 py-6 text-center sm:px-5 sm:py-12" data-id="element-116" data-mp="3j8ixz1o3okvr">
        <div className="animate-hero-copy" data-id="element-117" data-mp="3j6od1nctwsro">
          <p className="font-sans text-[0.66rem] font-semibold uppercase tracking-editorial text-gold-deep" data-id="element-118" data-mp="3o6kg9kdpcg66">
            Wellness Digital Pro™
          </p>
          <h1 className="mx-auto mt-2.5 max-w-[20ch] font-display text-[1.95rem] font-semibold leading-[1.12] text-charcoal sm:max-w-none sm:text-5xl" data-id="element-119" data-mp="39cpfl1np9x62">
            Hacé que tu Instagram trabaje para vos.
            <span className="mt-1 block text-gold-deep" data-id="element-120" data-mp="358re4kawka9u">
              Más consultas. Menos improvisación.
            </span>
          </h1>
        </div>

        <img src={HERO_IMG} alt="MegaPack Wellness Digital Pro: seis tomos impresos sobre superficie de piedra junto a una notebook" width={HERO_IMG_WIDTH} height={HERO_IMG_HEIGHT} fetchPriority="high" decoding="async" sizes="(max-width: 640px) 54vw, 400px" style={{
        aspectRatio: `${HERO_IMG_WIDTH} / ${HERO_IMG_HEIGHT}`
      }} className="animate-hero-media mx-auto mt-3.5 block h-auto w-[54%] max-w-[278px] rounded-2xl object-contain shadow-[0_26px_54px_-32px_rgba(28,27,25,0.4)] sm:mt-6 sm:w-[76%] sm:max-w-[400px]" data-id="element-121" data-mp="2qleookhz5ke6" />

        <p className="mx-auto mt-2.5 max-w-xl font-sans text-[0.85rem] leading-relaxed text-charcoal/70 sm:mt-5 sm:text-sm" data-id="element-122" data-mp="ichx2zikc81y">
          El sistema completo para profesionales de Yoga, Pilates, Coaching, Meditación y Terapias
          que quieren atraer alumnos y clientes con Instagram. Contenido + estrategia + scripts
          listos para usar.
        </p>

        <p className="mt-3.5 font-sans text-base font-semibold text-charcoal sm:mt-4 sm:text-lg" data-id="element-123" data-mp="111y8wizp7mxo">
          MegaPack 6 en 1 + 5 bonos
        </p>

        <PriceBlock className="mt-2" data-id="element-124" data-mp="x37b09nes19i" />

        <div className="mt-3.5 flex justify-center sm:mt-4" data-id="element-125" data-mp="3ltgnrsgieupe">
          <CTAButton className="w-full max-w-[22rem] whitespace-nowrap px-5" data-id="element-126" data-mp="3lqm1dvdxqztc" />
        </div>

        <p className="mt-2.5 font-sans text-[0.72rem] text-charcoal/60" data-id="element-127" data-mp="3htga4a18inje">
          Acceso inmediato · Garantía 7 días · Pago seguro
        </p>

        <div className="mt-5 flex flex-wrap items-center justify-center gap-2" data-id="element-128" data-mp="21a4rlpufu83c">
          {badges.map(b => <span key={b.label} className="inline-flex items-center gap-1.5 rounded-full border border-stone bg-ivory px-3 py-1.5 font-sans text-[0.68rem] font-medium text-charcoal/80" data-id="element-129" data-mp="268y5hjdn0141">
              <b.icon className="h-3.5 w-3.5 text-gold-deep" aria-hidden data-id="element-130" data-mp="2fzj3p5pef3mf" />
              {b.label}
            </span>)}
        </div>
      </div>

      <div className="relative border-t border-stone bg-ivory/70" data-id="element-131" data-mp="2ozz0jwbmzcib">
        <div className="mx-auto flex max-w-4xl flex-wrap items-center justify-center gap-x-5 gap-y-1.5 px-5 py-3 text-center font-sans text-[0.74rem] text-charcoal/70" data-id="element-132" data-mp="2oynwrwi6y4r7">
          {PRODUCT_FACTS.map((fact, i) => <React.Fragment key={fact} data-id="element-133" data-mp="zlaq40mlw4mx" data-mpi={i}>
              {i > 0 && <span className="hidden h-3.5 w-px bg-stone-deep sm:block" aria-hidden data-id="element-134" data-mp="zm2lbacak0co" />}
              <span data-id="element-135" data-mp="4a2s9dsxexwg">{fact}</span>
            </React.Fragment>)}
        </div>
      </div>
    </section>;
}